export default {
    'PreorderId': 'e6cfa046-299c-4969-86b7-000b40cba6d3',
    'MerchantName': 'MeuCheckout Master Key',
    'OrderNumber': '2782019112223135',
    'MerchantLayoutConfiguration': {
        'Id': 12,
        'TestModeEnabled': false,
        'HasLogo': true,
        'BackgroundColor': '246ec1',
        'IsCustomizationEnabled': false
    },
    'ShoppingCartItens': [{
        'UnitPrice': 100,
        'Quantity': 3,
        'Name': 'Bala Halls',
        'Description': null,
        'TypeId': 1,
        'Sku': null,
        'ZipCode': '20020080',
        'Weight': 554,
        'ShowDescription': false
    }, {
        'UnitPrice': 1000,
        'Quantity': 3,
        'Name': 'Galaxy SIII',
        'Description': null,
        'TypeId': 1,
        'Sku': null,
        'ZipCode': '20020080',
        'Weight': 855,
        'ShowDescription': false
    }, {
        'UnitPrice': 800,
        'Quantity': 2,
        'Name': 'Cerveja Hoegaarden',
        'Description': null,
        'TypeId': 1,
        'Sku': null,
        'ZipCode': '20020080',
        'Weight': 216,
        'ShowDescription': false
    }],
    'PaymentMethods': [{
        'PaymentType': 4,
        'Id': 10,
        'Image': 'visa',
        'Description': 'Cartão de Débito Visa',
        'MaxNumberOfPayments': 12
    },
    {
        'PaymentType': 1,
        'Id': 2,
        'Image': 'master',
        'Description': 'Cartão de Crédito Master',
        'MaxNumberOfPayments': 12
    },
    {
        'Description': 'Boleto BB',
        'Id': 5,
        'Image': 'bb',
        'MaxNumberOfPayments': 1,
        'PaymentType': 2
    },
    {
        'Description': 'Pix',
        'Id': 50,
        'Image': 'pix',
        'MaxNumberOfPayments': 1,
        'PaymentType': 6
    },
    {
        'Description': 'Pix Open Finance',
        'Id': 98,
        'Image': 'pix',
        'MaxNumberOfPayments': 1,
        'PaymentType': 9
    },
    {
        'Description': 'QR Code Crédito',
        'Id': 36,
        'Image': 'qrcode',
        'MaxNumberOfPayments': 12,
        'PaymentType': 5
    },
    {
        'Description': 'Cartão de Débito Elo (Alimentação/Refeição)',
        'Id': 39,
        'Image': 'Alelo',
        'MaxNumberOfPayments': 1,
        'PaymentType': 99
    },
    {
        'Description': 'Cartão de Crédito Multibenefícios (Alimentação/Refeição)',
        'Id': 41,
        'Image': 'elo',
        'MaxNumberOfPayments': 1,
        'PaymentType': 8
    },
    ],
    'PaymentType':[
        {
            'Type':1,
            'Description':'Cartão de Crédito',
            'Discount':0
        },
        {
            'Type':4,
            'Description':'Cartão de Débito',
            'Discount':0
        },
        {
            'Type':5,
            'Description':'QR Code Pay',
            'Discount':0
        },
        {
            'Type':2,
            'Description':'Boleto',
            'Discount':10
        },
        {
            'Type': 6,
            'Description':'Pix',
            'Discount':0
        },
        {
            'Type': 8,
            'Description':'Alimentação e Refeição',
            'Discount':0
        },
        {
            'Type': 9,
            'Description':'Pix Open Finance',
            'Discount':0
        },
        {
            'Type': 99,
            'Description':'Alimentação / Refeição',
            'Discount':0
        },
    ],
    // 'Customer': {
    //     'Name': 'William',
    //     'Email': 'wmoura@braspag.com.br',
    //     'Phone': '19999999999',
    //     'Identity': '123456789'
    // },
    'Customer': {
        'Name': null,
        'Email': null,
        'Phone': null,
        'Identity': null,
        'AcceptAds': false
    },
    'ShippingAddress': {
        'ZipCode': '99010010',
        'Street': 'Avenida Marechal Câmara',
        'Number': '23',
        'Complement': 'torre 1',
        'District': 'Centro',
        'City': 'Rio de Janeiro',
        'State': 'RJ'
    },
    // 'ShippingAddress': {
    //     'Street': null,
    //     'Number': null,
    //     'Complement': null,
    //     'ZipCode': null,
    //     'City': null,
    //     'State': null,
    //     'Country': null
    // },
    // 'ShippingType': 1,
    'ShippingMethodsCorreios': [
        {
            'Id': '3fd572b7-8873-4fab-9184-8ccca8685173',
            'Description': 'Sedex 10',
            'Price': 1500,
            'DeadLine': 3,
            'CarrierId': 0,
            'FormattedPrice': 'R$ 15,00'
        },
        {
            'Id': '4fd572b7-8873-4fab-9184-8ccca8685174',
            'Description': 'PAC',
            'Price': 3400,
            'DeadLine': 7,
            'CarrierId': 0,
            'FormattedPrice': 'R$ 34,00'
        }
    ],
    // 'ShippingType': 2,
    'ShippingMethods': [
        {
            'Id': 'b93f156a-9dbc-4379-9dc0-a103611029b0',
            'Description': 'Entrega Loggi',
            'Price': 2730,
            'DeadLine': null,
            'CarrierId': 1,
            'FormattedPrice': 'R$ 27,30'
        },
        {
            'Id': 'e82046f0-9146-40d8-8649-526bffb45161',
            'Description': 'Serviço de entrega próprio',
            'Price': 1200,
            'DeadLine': null,
            'CarrierId': 0,
            'FormattedPrice': 'R$ 12,00'
        },
        {
            'Id': 'fd2a37bd-b370-4e01-957e-a074eb1ed311',
            'Description': 'UPS Express',
            'Price': 2000,
            'DeadLine': null,
            'CarrierId': 0,
            'FormattedPrice': 'R$ 20,00'
        }
    ],
    'ShippingType': 3,
    'ShippingMethod': [
        {
            'Id': '15812efe-5ec1-4732-8f20-5c852757a18c',
            'Description': 'Frete Grátis',
            'Price': 0,
            'DeadLine': null,
            'CarrierId': 0,
            'FormattedPrice': 'R$ 00,00'
        },
        {
            'Id': 'fd2a37bd-b370-4e01-957e-a074eb1ed311',
            'Description': 'UPS Express',
            'Price': 2000,
            'DeadLine': null,
            'CarrierId': 0,
            'FormattedPrice': 'R$ 20,00'
        }
    ],
    'Discount': {
        'TypeId': 2,
        'Amount': 0,
        'Percentage': 20
    },
    // 'RecurrentPayment': {
    //     'Interval': 0,
    //     'EndDate': '20/01/2050'
    // },
    AccessTokenMpiVersionTwo: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6Ims5SmpxWlJ1cW1xdHdBQzRwV1hub3RLMmxBayJ9.eyJjbGllbnRfbmFtZSI6IlFBXzNEU19BdXRoZW50aWNhdG9yIiwiY2xpZW50X2lkIjoiZGJhM2E4ZGItZmE1NC00MGUwLThiYWItN2JmYjliNmYyZTJlIiwic2NvcGVzIjoie1wiU2NvcGVcIjpcIkJyYXNwYWczRFNBdXRoZW50aWNhdG9yXCIsXCJDbGFpbXNcIjpbe1wiTmFtZVwiOlwiTWVyY2hhbnROYW1lXCIsXCJWYWx1ZXNcIjpbXCJNUEkgUUEgU3RvcmVcIl19LHtcIk5hbWVcIjpcIkVzdGFibGlzaG1lbnRDb2RlXCIsXCJWYWx1ZXNcIjpbXCIxMDA1NTVcIl19LHtcIk5hbWVcIjpcIk1DQ1wiLFwiVmFsdWVzXCI6W1wiNTU1NVwiXX0se1wiTmFtZVwiOlwiUmVmZXJlbmNlSWRcIixcIlZhbHVlc1wiOltcImU4ZTFhYmIyLWM1OTQtNDVmYi1hODFmLTVjMGY5NDkyMWRiOVwiXX1dfSIsImlzcyI6Imh0dHBzOi8vYXV0aHNhbmRib3guYnJhc3BhZy5jb20uYnIiLCJhdWQiOiJVVlF4Y1VBMmNTSjFma1EzSVVFbk9pSTNkbTl0Zm1sNWVsQjVKVVV1UVdnPSIsImV4cCI6MTYyOTIxMTA3NywibmJmIjoxNjI5MTI0Njc3fQ.Tgjv3Y4l24nTqDcnXLbtGLgVtDzldzt20bki5oL4_8GBRhj8OXQ65tOJymMJA_yvkIF1V9kgUOuC5HJ8nylaZx4G9o01K1nzML6LQpIp9glGZe7HNwFVJzSp3j-ar5SxVXUCX1VodalCLNeP-vK5fU88cWbyjHKK0cT8pA7p3mA8-MiHdB3wZykZ1NcsFnC0yKti9TjPEIP543u60GLvMN4KHoj3h_CrVFN31hrIEaTKPYacUPSv2YQKSK9RrhmpW3Y-gwJVOz1j6ykFVvZZvxFlbjCrsG0WkW2cBa2WWr2JI-R0deSqJQKWnb7cys7mi4b8jhnEj7xgPEcMYFI0gg',
    MpiDataOnly: false,
    EnvironmentToMpi: 'SDB',
    DebugMpiScript: true,
    MpiCreditAuthenticationEnabled: false,
    MpiDebitAuthenticationEnabled: false,
    MinimumInstallmentAmount: 1,
    WalletMethodInformation: [
        {
            'Id': 1,
            'Name': 'Google Pay',
            'Description': 'Integração com Wallet - Google Pay. Apenas transação de crédito',
            'ImageName': 'googlepay.gif',
            'WalletCredentials': {
                'GatewayMerchantId': 'A6E88921-C8CB-49F2-974B-DC3694AB0047',
                'MerchantId': 'BCR2DN4TWWP5DYZY'
            }
        },
        {
            'Id': 2,
            'Name': 'ClickToPay',
            'Description': 'Implementação de Click to Pay (apesar de não ser necessariamente uma Wallet, segue o mesmo padrão',
            'ImageName': 'clicktopay.gif',
            'WalletCredentials': {
                'DpaId': '265D98D2-FB2C-446C-BC3A-6A1E5C41D8B8'
            }
        },
        {
            'Id': 3,
            'Name': 'Apple Pay',
            'Description': 'Integração com wallet - Apple Pay. Apenas transação de crédito',
            'ImageName': 'applepay.gif',
            'AllowedInstallments': 8,
            'WalletCredentials': {
                'MerchantIdentifier': '8810A66D-7DD0-47EA-8209-CC19EF7F80D3'
            }
        }
    ],
    AffiliationCodeAmex: '',
    // FixedInstallments: 5,
    SupportedCardBrands: [
        {
            Name: 'Undefined',
            IsCredit: false,
            IsDebit: false
        },
        {
            Name: 'Visa',
            IsCredit: true,
            IsDebit: true,
            Wallets: [
                'GooglePay',
                'ClickToPay',
                'ApplePay'
            ]
        },
        {
            Name: 'Mastercard',
            IsCredit: true,
            IsDebit: true,
            Wallets: [
                'GooglePay',
                'ClickToPay',
                'ApplePay'
            ]
        },
        {
            Name: 'Amex',
            IsCredit: true,
            IsDebit: false,
            Wallets: [
                'GooglePay',
                'ApplePay'
            ]
        },
        {
            Name: 'Diners',
            IsCredit: true,
            IsDebit: false,
            Wallets: []
        },
        {
            Name: 'Elo',
            IsCredit: true,
            IsDebit: true,
            Wallets: [
                'ApplePay'
            ]
        },
        {
            Name: 'Aura',
            IsCredit: true,
            IsDebit: false,
            Wallets: []
        },
        {
            Name: 'Jcb',
            IsCredit: true,
            IsDebit: false,
            Wallets: [
                'ApplePay'
            ]
        },
        {
            Name: 'Discover',
            IsCredit: false,
            IsDebit: false
        },
        {
            Name: 'Hipercard',
            IsCredit: true,
            IsDebit: false,
            Wallets: []
        }
    ]
};
